import React from "react";
import { Col, Row } from "react-bootstrap";
import SearchTable from "../../../components/search-table/SearchTable";

const Seeker = () => {
  return (
    <Row>
      <Col col={12} className="mb-4">
        <SearchTable />
      </Col>
    </Row>
  );
};

export default Seeker;
